export const Types = {
  GET_REQUEST: 'terms_of_use/GET_REQUEST',
  GET_SUCCESS: 'terms_of_use/GET_SUCCESS',
};

const INITIAL_STATE = {
  terms_of_use: 'Carregando...',
  loading: false,
};

export default (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case Types.GET_REQUEST:
      return { ...state, loading: true };
    case Types.GET_SUCCESS:
      if (action.payload.data === null) {
        return state;
      }
      return { terms_of_use: action.payload.data, loading: false, error: null };
    default:
      return state;
  }
};

export const Creators = {
  getTermsOfUseRequest: () => ({ type: Types.GET_REQUEST }),
  getTermsOfUseSuccess: data => ({
    type: Types.GET_SUCCESS,
    payload: { data },
  }),
};



// WEBPACK FOOTER //
// ./src/store/ducks/termsOfUse.js